export const OPTIONS = {
  support: 'support',
  pay: 'pay',
  coupon: 'coupon'
};

export const defaultOption = OPTIONS.support;
